import React, { useEffect } from 'react';
import { t } from '@lingui/macro';
import { FaFont, FaSearchMinus } from 'react-icons/fa';

import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import { AccessibilityOption } from './AccessibilityButton';

const DislexicOption = () => {
  const { isDislexic, setIsDislexic } = useAccessibilityContext();

  useEffect(() => {
    if (isDislexic) {
      enableDislexic();
    } else {
      disableDislexic();
    }
  }, [isDislexic]);

  function toggleDislexico() {
    if (setIsDislexic) {
      setIsDislexic(!isDislexic);
    }
  }

  function enableDislexic() {
    document.querySelector('body')?.classList.add('dislexic');
  }

  function disableDislexic() {
    document.querySelector('body')?.classList.remove('dislexic');
  }

  return (
    <AccessibilityOption
      name={'Fuente disléxicos'}
      icon={<FaFont className="h-3 w-3 fill-white" />}
      onClick={() => toggleDislexico()}
    />
  );
};

export default DislexicOption;
